import api from "./api";

// Admin Stats
export const getAdminStats = async () => {
  const response = await api.get("/admin/stats");
  return response.data;
};

// User Management
export const getAllUsers = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await api.get(`/admin/users?${queryString}`);
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post("/admin/users", userData);
  return response.data;
};

export const updateUserStatus = async (userId, status) => {
  const response = await api.put(`/admin/users/${userId}/status`, { status });
  return response.data;
};

// Subscription Management
export const getSubscriptionRequests = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await api.get(`/admin/subscription-requests?${queryString}`);
  return response.data;
};

export const updateSubscriptionStatus = async (
  subscriptionId,
  action,
  reason = null
) => {
  const response = await api.put(
    `/admin/subscriptions/${subscriptionId}/status`,
    {
      action,
      reason,
    }
  );
  return response.data;
};

export const updateExpiredSubscriptions = async () => {
  const response = await api.post("/admin/subscriptions/update-expired");
  return response.data;
};
